import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllJobs, SavedJobs } from "../../store/jobSlice";
import JobList from "../Jobs/JobList";
import AdCard from "../../templates/AdCard";
import QuoteCard from "../../templates/QuoteCard";

export default function Home() {
  const dispatch = useDispatch();
  const { jobs, savedJobs, savedJobsStale } = useSelector((state) => state.job);
  const [filter, setFilter] = useState("all");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    if (filter === "saved" && savedJobsStale && user) {
      dispatch(SavedJobs({ UserId: user.$id }));
    }
  }, [filter, dispatch, savedJobsStale, user]);

  useEffect(() => {
    if (!jobs || jobs.length === 0) {
      dispatch(getAllJobs("Job"));
    }
  }, [dispatch, jobs]);

  const handleFilter = (type) => {
    setFilter(type);
    setIsDropdownOpen(false);
  };

  const filteredJobs =
    filter === "all"
      ? jobs.filter((job) => job.Type === "Job")
      : jobs.filter((job) => job.Type === "Job" && savedJobs.includes(job.$id));

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Quote Section */}
      <section className="max-w-6xl mx-auto px-4 pt-16 pb-4">
        <QuoteCard />
      </section>

      {/* Ad under quote */}
      <section className="max-w-6xl mx-auto px-4 mb-3">
        <AdCard slot="9326257490" format="fluid" />
      </section>

      {/* Job List + Filter Section */}
      <section className="max-w-6xl mx-auto px-4 pb-6 pt-3">
        <div className="flex items-center justify-between mb-2 border-b-4 border-pink-500 pb-1">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800">
            Latest Jobs
          </h2>

          {/* Filter Dropdown */}
          <div className="relative inline-block text-left" ref={dropdownRef}>
            <button
              type="button"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-3 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              Filter: {filter === "all" ? "All Jobs" : "Saved Jobs"}
              <svg
                className="-mr-1 ml-2 h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.08 1.04l-4.25 4.25a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z"
                  clipRule="evenodd"
                />
              </svg>
            </button>

            {isDropdownOpen && (
              <div className="origin-top-right absolute right-0 mt-1 w-40 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10">
                <div className="py-1">
                  <button
                    onClick={() => handleFilter("all")}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    All Jobs
                  </button>
                  <button
                    onClick={() => handleFilter("saved")}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    Saved Jobs
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Job List */}
        <div className="mb-3">
          <JobList jobs={filteredJobs} adFrequency={0} jobsPerPage={90} />
        </div>

        {/* Inline Ad after job list */}
        <div className="mt-2 mb-4">
          <AdCard slot="9326257490" format="fluid" />
        </div>
      </section>
    </div>
  );
}
